<section class="ftco-section ftco-no-pt ftco-no-pb ftco-services-2 bg-light">
    <div class="col-sm-12" style="padding-left: 1% !important;padding-right: 1% !important;">
        <div class="modal-body" style="padding: 1% !important;">
            <div class="card bg-light"
                style="padding-left: 1% !important;padding-right: 1% !important;border: 2px solid black; margin-top: 0px; margin-bottom: 0px;">

                <div class="container contact" style="padding: 1% !important;">
                    <div class="row">
                        <div class="col-sm-12 col-lg-4 form-text" style="padding: 1% !important;">
                            <div class="contact-info">
                                <img src="./assets/images/logo_with_caption.png"
                                    style="width: 160px;margin-bottom: 35%; padding-top: 30%;" alt="image" />

                                <div>
                                    <h5 style="color:white">Please download our app on</h5>
                                    <app-mobile-app-badges></app-mobile-app-badges>
                                </div>

                            </div>
                        </div>

                        <div class="col-sm-12 col-lg-8 form-bodyy"
                            style="padding-top: 1%;padding-bottom: 1%;margin-top: 0px;margin-bottom: 0px;">
                            <h2
                                style="color: #004aad;font-weight: bold;padding: 0.5% 1%;margin: 0px;padding-left: 1rem;">
                                Feedback</h2>
                            <div class="contact-form">
                                <form #covidfeebackForm="ngForm" (ngSubmit)="feedbackSubmit()">
                                    <div class="form-group">
                                        <div class="col-sm-10">
                                            <input type="text" class="form-control" id="fname" placeholder="Your Name"
                                                name="fullname" [(ngModel)]="data.name" #fullname="ngModel" required />
                                        </div>

                                        <div class="col-sm-10">
                                            <div *ngIf="fullname.invalid && (fullname.dirty || fullname.touched)"
                                                class="mt-2 alert alert-danger">
                                                <div *ngIf="fullname.errors.required">
                                                    Name is required.
                                                </div>
                                                <div *ngIf="fullname.errors.FieldValidator">
                                                    Invalid Name.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="col-sm-10">
                                            <input type="email" class="form-control" id="email" placeholder="Your email"
                                                name="useremail" FieldValidator="email" [(ngModel)]="data.email"
                                                #useremail="ngModel" required />
                                        </div>
                                        <div class="col-sm-10">
                                            <div *ngIf="useremail.invalid && (useremail.dirty || useremail.touched)"
                                                class="mt-2 alert alert-danger">
                                                <div *ngIf="useremail.errors.required">
                                                    Email is required.
                                                </div>
                                                <div *ngIf="useremail.errors.FieldValidator">
                                                    Invalid Email.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="col-sm-10">
                                            <select name="country" class="custom-select custom-select mb-3"
                                                [(ngModel)]="this.selected_country" #user_country="ngModel"
                                                placeholder="Choose your country" required>
                                                <option value="" disabled selected>Choose your country</option>
                                                <option *ngFor="let country of this.countries" value={{country.value}}>
                                                    {{country.label}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-sm-10">
                                            <div *ngIf="user_country.invalid && (user_country.dirty || user_country.touched)"
                                                class="mt-2 alert alert-danger">
                                                <div *ngIf="user_country.errors.required">
                                                    Country is required.
                                                </div>
                                                <!-- <div *ngIf="useremail.errors.FieldValidator">
                                                    Invalid Email.
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="control-label col-sm-10" for="email">Rate your experience with our
                                            product</label>
                                        <div class="col-sm-10">
                                            <p-rating [(ngModel)]="data.rating" name="rating" #rating="ngModel"
                                                [cancel]="false" required></p-rating>
                                        </div>
                                        <div class="col-sm-10">
                                            <div *ngIf="rating.invalid && (rating.dirty || rating.touched)"
                                                class="mt-2 alert alert-danger">
                                                <div *ngIf="rating.errors.required">
                                                    Your rating is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="col-sm-10">
                                            <textarea class="form-control" maxlength="1000" name='message'
                                                placeholder="Your Feedback (Optional)" #message='ngModel'
                                                [(ngModel)]="data.message" id="comment" style="height: 10%;"></textarea>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="p-field-checkbox col-sm-10">
                                            <p-checkbox [(ngModel)]="data.has_consented" [binary]="true" name="consent">
                                            </p-checkbox>

                                            <span style="font-size:14px">
                                                OPTIONAL - I agree to let eGlobalDoctors use my name and review for
                                                marketing purposes (Your email will not be used and will be kept
                                                private)
                                            </span>

                                        </div>
                                    </div>


                                    <div class="form-group">
                                        <div class="col-sm-10">
                                            <re-captcha *ngIf="recaptcha_Reset" class="recaptcha ng-valid"
                                                name="recaptcha" matInput
                                                style="display: flex;align-content: center;justify-content: center;"
                                                (resolved)="resolved($event)" [(ngModel)]="data.recaptcha"
                                                #recaptcha="ngModel" [siteKey]="sitekey" required></re-captcha>
                                        </div>
                                    </div>


                                    <div class="form-group">
                                        <div class="col-sm-offset-2 col-sm-10"
                                            style="display: flex;align-content: center;justify-content: center;">
                                            <button type="submit" style="margin: auto;" class="btn btn-default"
                                                [disabled]="!covidfeebackForm.valid || this.api_result.Posting || !valid_source">Submit</button>
                                            <button type="button" style="margin: auto;" class="btn btn-default"
                                                (click)="gotoHome()" [disabled]="this.api_result.Posting">Back</button>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <p-progressSpinner [style]="{width: '50px', height: '50px'}"
                                            *ngIf="this.api_result.Posting" strokeWidth="6">
                                        </p-progressSpinner>
                                        <div class="col-sm-10">
                                            <app-error-messages [api_result]="this.api_result"></app-error-messages>

                                            <div *ngIf="this.api_result.PromiseResult.success!=null && this.api_result.PromiseResult.success"
                                                class="alert alert-success" style="color: #155724;">
                                                Your Feeback has been submitted Successfully!
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>

                    </div>
                </div>

            </div>

        </div>
    </div>
    <!-- </div>     -->
    <!-- </div> -->
</section>